import { render, staticRenderFns } from "./Arrow.vue?vue&type=template&id=08b71e66&scoped=true&"
import script from "./Arrow.vue?vue&type=script&lang=js&"
export * from "./Arrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b71e66",
  null
  
)

export default component.exports